<template>
	<div class="tab-pane" id="additionalDetails">
    <h3 class="info-text mb-0">Additional Details</h3>
    <p class="text-center text-secondary mb-4">
      <em>Details about Cloudflare and special instructions</em>
    </p>
    <div class="row justify-content-center">
      <div class="col-12 pr-5 pl-5">
				<div class="row">
					<div class="col-12">
						<div class="form-group">
              <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : haveCloudflare, 'bootstrap-switch-off bootstrap-switch-focused' : !haveCloudflare }">
                <div class="bootstrap-switch-container" @click="haveCloudflare = !haveCloudflare">
                  <span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
                  <span class="bootstrap-switch-label"></span>
                  <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
                </div>
              </div>
              <label for="haveSSH" class="ml-2" style="font-size: 14px;">
				  Do you have Cloudflare, Sucuri, or any other third party DNS or CDN service that you have access to?
              </label>
            </div>
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">

							<div class="row" v-if="haveCloudflare">
								<div class="col-sm-12 col-md-4">
									<div class="form-group">
										<label>Select DNS/CDN Service
											<strong class="text-danger">*</strong>
										</label>
										<select class="form-control" required v-model.trim="cdnType">
											<option value="Cloudflare">Cloudflare</option>
											<option value="Sucuri">Sucuri</option>
											<option value="Other">Other</option>
										</select>
									</div>
								</div>
								<div class="col-sm-12 col-md-4" key="cloudflareEmail">
									<div class="form-group">
										<label for="cloudflareEmail">Username / Email Address
											<strong class="text-danger">*</strong>
										</label>
										<input type="text" class="form-control" id="cloudflareEmail" aria-describedby="domainRegisterName"  required @input="cfEmailValid" v-model.trim="cfEmail">
									</div>
								</div>
								<div class="col-sm-12 col-md-4" key="cloudflarePassword">
									<div class="form-group">
										<label for="cloudflarePassword">Password
											<strong class="text-danger">*</strong>
										</label>
										<input type="text" class="form-control" id="cloudflarePassword" aria-describedby="domainRegisterName"  required @input="cfPassValid" v-model.trim="cfPass">
									</div>
								</div>
							</div>
						</transition>
						<div class="mb-2">
							<small>
								<span class="badge bg-violate mb-0">Please Note</span>
								We highly recommend the use of Cloudflare. It’s completely free, offers performance, security and reliability benefits and will be configured entirely by us. If you do not have an account, we will create one for you. If you do have an account even if it’s not in use, please provide those login details here.
							</small>
						</div>
						<br/><hr/><br/>
						<!-- M & C -->
						<div class="form-group">
							<div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : isMAndC, 'bootstrap-switch-off bootstrap-switch-focused' : !isMAndC }">
								<div class="bootstrap-switch-container" @click="isMAndC = !isMAndC">
									<span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
									<span class="bootstrap-switch-label"></span>
									<span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
								</div>
							</div>
							<label for="haveSSH" class="ml-2" style="font-size: 14px;">
								Will we be migrating anything with membership or ecommerce?
							</label>
						</div>
						<div class="mb-2">
							<small>
								<span class="badge bg-violate mb-0">Please Note</span>
								In order to prevent data loss a brief maintenance period is part of our migration process. We will migrate the site initially, put the site into maintenance mode on the old host, sync the latest database and only then go live on BigScoots. This will ensure no orders, transactions or content is missed at any point during the migration or after since the site on will remain in maintenance mode with the old host.
							</small>
						</div>
						<br/><hr/><br/>
						<div class="form-group">
							<label style="font-size:14px;">
								<div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate mr-2" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : shouldAddCollaborator, 'bootstrap-switch-off bootstrap-switch-focused' : !shouldAddCollaborator }">
									<div class="bootstrap-switch-container" @click="shouldAddCollaborator = !shouldAddCollaborator">
										<span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
										<span class="bootstrap-switch-label"></span>
										<span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
									</div>
								</div>
								Do you have any team member (designer, developer, SEO, marketer, WP maintenance service, etc.) that you would like to share access with now by adding them on as a collaborator to your account?
							</label>
						</div>
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
							<div class="row" v-if="shouldAddCollaborator">
								<div class="col-sm-11 col-md-11">
									<div class="form-group">
										<label for="cloudflareEmail">Collaborators to be assigned
											<strong class="text-danger">*</strong>
										</label>
										<tags-input element-id="collaborator-email-tags"
													v-model="selectedCollaborators"
													:validate="validateEmail"
													:add-tags-on-comma="true"
													:add-tags-on-space="true"
													:add-tags-on-blur="true"
													@tags-updated="addNewTaggedCollaborator"
													placeholder="Type an email address and press enter, space or comma"
										></tags-input>
										<label v-if="errMessage !== ''" class="is-invalid">{{errMessage}}</label>
<!--										<multi-select v-model="selectedCollaborators" :options="collaboratorsOptions" tag-placeholder="Add this as collaborator"-->
<!--													  :multiple="true" :taggable="true" placeholder="Type an email address and press enter"-->
<!--													  @tag="addNewTaggedCollaborator" @input="commitChanges"/>-->
<!--										-->
									</div>
								</div>
								<div class="col-sm-1 col-md-1 bt-bl">
									<button type="button" class="btn btn-outline-primary btn-sm" @click="openCollaboratorModal"><i style="font-size: 23px" class="fa fa-users"></i></button>
								</div>
							</div>
						</transition>
						<div class="mb-2">
							<small>
								<span class="badge bg-violate mb-0">Please Note</span>
								This will give the added collaborator full access to the domains included in this migration request. You can remove, adjust or add new collaborator permissions at any time from your WPO portal.
							</small>
						</div>
						<br/><hr/><br/>
						<div class="form-group">
              <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : haveSpecialRewriteRule, 'bootstrap-switch-off bootstrap-switch-focused' : !haveSpecialRewriteRule }">
                <div class="bootstrap-switch-container" @click="haveSpecialRewriteRule = !haveSpecialRewriteRule">
                  <span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
                  <span class="bootstrap-switch-label"></span>
                  <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
                </div>
              </div>
              <label for="haveSSH" class="ml-2" style="font-size: 14px;">
				  Do you have any website redirects?
<!--                Are there any special .htaccess rewrite or nginx rules that need to be discussed?-->
              </label>
            </div>
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
							<div class="form-group" v-if="haveSpecialRewriteRule">
								<label for="specialRewriteRule" style="font-size: 14px;">Please mention the special rules <strong class="text-danger">*</strong></label>
								<textarea placeholder="Example: Does the dates in your URL get removed? https://domain.com/2019/09/postname => https://domain.com/postname" class="form-control" id="specialRewriteRule" required rows="3" @input="specialRewriteRuleValid" v-model="rewriteRule"></textarea>
							</div>
						</transition>
						<br/><hr/><br/>
						<div class="form-group">
							<label for="specialRewriteRule" style="font-size: 14px;">Any other special instructions?</label>
							<textarea class="form-control" rows="5" v-model="specialInstruction"></textarea>
							<small id="specialRewriteRuleHelp" class="form-text text-muted"><span class="badge bg-violate mb-0">Please Note</span> We will work to fully understand your entire site top to bottom, any information included here that you would like to bring to our attention to will simply work to help speed up the migration process and will never substitute for our care and attention to extreme detail of your site.</small>
						</div>
					</div>
				</div>
      </div>
    </div>
		<!-- Modal -->
		<div class="modal fade" id="collaboratorModal" tabindex="-1" role="dialog" aria-labelledby="collaboratorModalLongTitle" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Select Pre-Defined Collaborators</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<blockquote class="blockquote" @click="addNewTaggedCollaborator('support@nerdpress.net')">
							<p class="mb-0">NerdPress</p>
							<footer class="blockquote-footer">support@nerdpress.net</footer>
						</blockquote>
						<blockquote class="blockquote" @click="addNewTaggedCollaborator('support@imarkinteractive.com')">
							<p class="mb-0">iMarkInteractive</p>
							<footer class="blockquote-footer">support@imarkinteractive.com</footer>
						</blockquote>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import tagsInput from '@voerro/vue-tagsinput';
import '@voerro/vue-tagsinput/dist/style.css';
export default {
	name: "AdditionalDetails",
	components: { tagsInput },
	data () {
		return {
			collaboratorsOptions: [],
			selectedCollaborators: [],
			errMessage: ''
		}
	},
	computed: {
		shouldAddCollaborator: {
			get() {
				return this.$store.getters["migration/shouldAddCollaborator"];
			},
			set(newState) {
				this.$store.commit("migration/mutateAddCollaborator", newState);
			}
		},
		isMAndC: {
			get() {
				return this.$store.getters["migration/isMAndC"];
			},
			set(newState) {
				this.$store.commit("migration/mutateIsMAndC", newState);
			}
		},
		mOrC: {
			get() {
				return this.$store.getters["migration/mOrC"];
			},
			set(newState) {
				this.$store.commit("migration/mutateMOrC", newState);
			}
		},
		haveCloudflare: {
			get() {
				return this.$store.getters["migration/haveCloudflare"]
			},
			set(newState) {
				this.$store.commit("migration/haveCloudflareMutate", { state: newState })
			}
		},
		cdnType: {
			get() {
				return this.$store.getters["migration/cdnType"]
			},
			set(newState) {
				this.$store.commit("migration/cdnTypeMutate", newState)
			}
		},
		cfEmail: {
			get() {
				return this.$store.getters["migration/cfEmail"]
			},
			set(newEmail) {
				this.$store.commit("migration/cfEmailMutate", { email: newEmail })
			}
		},
		cfPass: {
			get() {
				return this.$store.getters["migration/cfPass"]
			},
			set(newPass) {
				this.$store.commit("migration/cfPassMutate", { password: newPass })
			}
		},
		haveSpecialRewriteRule: {
			get() {
				return this.$store.getters["migration/haveSpecialRewriteRule"]
			},
			set(newState) {
				this.$store.commit("migration/haveSpecialRewriteRuleMutate", { state: newState })
			}
		},
		rewriteRule: {
			get() {
				return this.$store.getters["migration/rewriteRule"]
			},
			set(newRule) {
				this.$store.commit("migration/rewriteRuleMutate", { rule: newRule })
			}
		},
		specialInstruction: {
			get() {
				return this.$store.getters["migration/specialInstruction"]
			},
			set(newDetails) {
				this.$store.commit("migration/specialInstructionMutate", { details: newDetails })
			}
		}
	},
	methods: {
		openCollaboratorModal () {
			/* eslint-disable */
			$("#collaboratorModal").modal("show");
			$('.modal-backdrop').removeClass("modal-backdrop");
			/* eslint-enable */
		},
		validateEmail (email) {
			console.log('validate called against: ', email);
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			this.errMessage = (re.test(String(email).toLowerCase())) ? '' : 'Please enter valid email address';
			return re.test(String(email).toLowerCase());
		},
		addNewTaggedCollaborator (newValue) {
			if (newValue) {
				if (this.selectedCollaborators.find(obj => obj.value === newValue)) {
					return false;
				}
				this.selectedCollaborators.push({ key: '', value: newValue })
			}
			const typedEmails = [];
			this.selectedCollaborators.forEach(obj => {
				typedEmails.push(obj.value);
			});
			console.log(typedEmails);
			this.$store.commit("migration/mutateAddedCollaborators", typedEmails);
			// if(this.selectedCollaborators.includes(newValue)) {
			// 	return false;
			// }
			// if (this.validateEmail(newValue)) {
			// 	if(!this.collaboratorsOptions.includes(newValue)){
			// 		this.collaboratorsOptions.push(newValue);
			// 	}
			// 	this.selectedCollaborators.push(newValue);
			// 	this.$store.commit("migration/mutateAddedCollaborators", this.selectedCollaborators);
			// 	this.errMessage = '';
			// } else {
			// 	this.errMessage = 'Please input valid email address';
			// }

		},
		// commitChanges () {
		// 	this.$store.commit("migration/mutateAddedCollaborators", this.selectedCollaborators);
		// },
		cfEmailValid() {
			/* eslint-disable */
      $("#cloudflareEmail").valid();
      /* eslint-enable */
		},
		cfPassValid() {
			/* eslint-disable */
      $("#cloudflarePassword").valid();
      /* eslint-enable */
		},
		specialRewriteRuleValid() {
			/* eslint-disable */
      $("#specialRewriteRule").valid();
      /* eslint-enable */
		}
	}
}
</script>
<style lang="scss">
	.tags-input-badge-selected-default{
		background-color: #5a7cfd !important;
		color: white;
	}
	.tags-input-badge-pill{
		padding-top: 0.6em;
		padding-bottom: 0.6em;
		border-radius: 5px !important
	}
	.tags-input-remove{
		top: 0.6em;
		&:before{
			background: #ef8157 !important;
		}
		&:after{
			background: #ef8157 !important;
		}
	}
	.multiselect__option--highlight{
		background: #5a7cfd !important;
	}
	.multiselect__option--highlight:after{
		background: #5a7cfd !important;
	}
	.multiselect__tag{
		background: #5a7cfd !important;
	}
	.multiselect__tag-icon:hover{
		background: red !important;
	}
	.multiselect__tag-icon:after {
		color: white !important;
	}
</style>
<style scoped lang="scss">
	.blockquote{
		&:hover{
			background: #dce4e6;
			cursor: pointer;
			box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);
			transition: 0.3s;
		}
	}
	.bt-bl{
		display: flex;
		align-items: flex-end;
	}
</style>
